import { useTranslation } from 'react-i18next'
import { Platform, Pressable } from 'react-native'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import Button from '@ui/buttons/Button'
import TileBlur from '@ui/tiles/TileBlur'
import { router } from 'expo-router'

export default function PrescriptionRecent() {
  const { t } = useTranslation(['vision'])
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const text = 'vision:source.sections.recent'

  const onPress = () => router.navigate('/vision/values')

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="option"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            <Button
              noninteractive
              animation={animation}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/prescription-saved.png'),
            imageWrapperStyle: {
              transformOrigin: 'bottom right',
              width: '75%',
              height: '75%',
            },
            imageStyle: {
              transform: [{ translateX: 1 }, { translateY: 1 }],
            },
            blur: Platform.select({ default: 50, web: 25 }),
            blurStyle: {
              opacity: 0.66,
              transform: [
                { translateX: 0 },
                { translateY: 0 },
                { scale: 0.75 },
              ],
            },
          }}
        />
      </Pressable>
    </>
  )
}
